import { render, staticRenderFns } from "./TeacherDocument.vue?vue&type=template&id=4b670eed&"
import script from "./TeacherDocument.vue?vue&type=script&lang=js&"
export * from "./TeacherDocument.vue?vue&type=script&lang=js&"
import style0 from "./TeacherDocument.vue?vue&type=style&index=0&id=4b670eed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports